export enum ChartTypes {
  LINE = 'line',
  BAR = 'bar',
  PIE = 'pie',
  FUNNEL = 'funnel'
}
